import React, { useState, useEffect } from 'react';
import { Container, Button } from 'react-bootstrap';
import userprofile from '../../assets/img/logo.png';
import Swal from 'sweetalert2';
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Col, Row, Form, Input } from 'antd';
import { useNavigate } from 'react-router-dom';

export default function Transferrespoint() {
  const navigate = useNavigate();

  const [rec_mob, setRecMob] = useState('');
  const [amount, setAmount] = useState('');
  const [total_bonus, setTotalBonus] = useState(0);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState();
  const user_id = localStorage.getItem("userid");
  const dev_id = localStorage.getItem("dev_id");

  // Load user profile
  const loadUserProfile = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/POM_get_user_profile`;
      const response = await axios.post(url, {
        app_id: process.env.REACT_APP_API_ID,
        user_id,
        dev_id
      });

      const objectRes = response.data;
      if (objectRes?.name) {
        setUserData(objectRes.name);
        setTotalBonus(objectRes.total_bonus || 0);
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  useEffect(() => {
    if (!user_id || !dev_id) {
      window.location.href = '/';
    } else {
      loadUserProfile();
    }
  }, []);

const updateUsername = async () => {
  if (!rec_mob || !amount) {
    Swal.fire({
      icon: 'warning',
      title: 'Missing Information',
      text: 'Please enter both mobile number and amount.',
    });
    return;
  }

  const confirm = await Swal.fire({
    title: 'Are you sure?',
    text: `Transfer ₹${amount} to ${rec_mob}?`,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, transfer it!'
  });

  if (!confirm.isConfirmed) return;

  try {
    setLoading(true);

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/transfer-point`,
      {
        rec_mob,
        amount,
        app_id: process.env.REACT_APP_API_ID,
        user_id,
      },
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    );

    setLoading(false);

    const res = response.data;

    if (res.status === "1") {
      Swal.fire({
        icon: 'success',
        title: 'Success!',
        text: res.message || 'Points transferred successfully!',
        timer: 2000,
        timerProgressBar: true,
      }).then(() => {
        navigate('/');
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Transfer Failed',
        text: res.message || 'Transfer failed. Please try again.',
      });
    }
  } catch (error) {
    setLoading(false);
    Swal.fire({
      icon: 'error',
      title: 'Server Error',
      text: error?.response?.data?.message || 'Something went wrong on the server.',
    });
    console.error('Transfer Error:', error);
  }
};



  return (
    <>
      <section id="profile">
        <Container fluid className="p-0">
          <div className="profilepage">
            <div className="profile">
              <img src={userprofile} className='img-fluid' alt="User Profile" />
            </div>
          </div>

          <div className="profiledetails">
            <div className="cardstyle">
              <h4 className='text-dark'>Transfer Points</h4>
              <div className="d-flex justify-content-between mb-2 balancebonus">
                <div className="mt-2">
            <Button type="button" className="btnbal bg-success W-75">
  BONUS : {total_bonus.toFixed(2)}
</Button>

                </div>
              </div>

              <Form
                name="transferPoints"
                layout="vertical"
                onFinish={updateUsername}
              >
                <Row gutter={16}>
                  <Col span={24}>
                    <Form.Item
                      label="Receiver Mobile Number"
                      name="rec_mob"
                      rules={[{ required: true, message: 'Please enter mobile number' }]}
                    >
                      <Input
                        placeholder="Enter receiver mobile number"
                        value={rec_mob}
                        onChange={(e) => setRecMob(e.target.value)}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item
                      label="Amount"
                      name="amount"
                      rules={[{ required: true, message: 'Please enter amount' }]}
                    >
                      <Input
                        placeholder="Enter points to transfer"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Button type="primary" className="submitbtn" htmlType="submit">
                      Submit
                    </Button>
                  </Col>
                </Row>
              </Form>
              <ToastContainer />
            </div>
          </div>
        </Container>
      </section>

      {loading && (
        <div className="spinner-wrapper">
          <div className="spinner">
            <div className="mesh-loader">
              <div className="set-one">
                <div className="circle"></div>
                <div className="circle"></div>
              </div>
              <div className="set-two">
                <div className="circle"></div>
                <div className="circle"></div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
